import { DiscountMappingConstant, discountMappingRequiredFieldList } from "presentation/constant/DiscountMapping/DiscountMappingConstant";
import { useDiscountMappingVM } from "presentation/hook/DiscountMapping/useDiscountMappingVM";
import { useMessageBarVM } from "presentation/hook/useMessageBar";
import { useANAInfoTracked } from "presentation/store/ANAInfo";
import { useDiscountMappingTracked } from "presentation/store/DiscountMapping/DiscountMappingProvider";
import { CriteriaItemContainer } from "presentation/view/components/CriteriaItemContainer";
import { NbisCommonField } from "presentation/view/components/NbisCommonField";
import { NbisIconButton } from "presentation/view/components/NbisIconButton";
import NumberInputComponent from "presentation/view/components/NumberInputComponent";
import { memo, useCallback, useMemo, useState } from "react";
import { FieldType, HPHBreadcrumb, HPHCheckbox, IconButton, IFieldValue, Loader } from "veronica-ui-component/dist/component/core";
import { Breadcrumb, SidebarCaption, Sidebarheader, SidebarTitle, StyledAction, StyledSidebar } from "veronica-ui-component/dist/component/core/styled/uiFramework.styled";

const DiscountMappingEditPanel = () => {
    const DISCOUNT_MAPPING_CONSTANT = DiscountMappingConstant.Table;
    const [isLoading, setIsLoading] = useState(false);
    const [discountMappingState] = useDiscountMappingTracked();
    const discountMappingVM = useDiscountMappingVM();
    const { currentEditRow, isAdd, isEdit, masterState } = discountMappingState;
    const { isSaveClicked, allFormState } = masterState;
    const messageBarVM = useMessageBarVM();
    const [anaInfoState] = useANAInfoTracked();
    const { allowUpdate, operatingUnit } = anaInfoState;


    const handleSave = useCallback(async () => {
        // if (!currentEditRow.billToCompanyCode) {
        //     messageBarVM.showError("Bill-To Company is mandatory.");
        //     return;
        // }
        // if (!currentEditRow.percentage) {
        //     messageBarVM.showError("Discount Percent is mandatory.");
        //     return;
        // }
        // if (!currentEditRow.activeInd) {
        //     messageBarVM.showError("Active Ind is mandatory.");
        //     return;
        // }
        setIsLoading(true);
        discountMappingVM.onSaveClicked();
        const data = await discountMappingVM.onSave(currentEditRow);
        if (data && data.success) {
            messageBarVM.showSuccess("Save Successfully.");
            discountMappingVM.searchAllDiscountMappingList().then((data) => {
                setIsLoading(false)
            }).catch(error => {
                setIsLoading(false)
            });
        } else {
            setIsLoading(false)
            data.data && messageBarVM.showError(data.data);
            return;
        }
    }, [discountMappingVM, currentEditRow, messageBarVM]);

    const handClose = useCallback(() => {
        discountMappingVM.onCloseEidtPanel();
    }, [discountMappingVM]);

    const onNumberFieldChange = useCallback((e: any, fieldName: string, fieldValue: any) => {
        discountMappingVM.onHeaderFieldChange(fieldName, fieldValue);
    }, [discountMappingVM]);

    const memoSubChgTypeOptions = useMemo(() => {
        const subChgTypeOptions = currentEditRow.chargeType ? discountMappingState.dynamicOptions.subChargeTypeDropdownOptions[currentEditRow.chargeType] : [];
        return subChgTypeOptions;
    }, [currentEditRow.chargeType, discountMappingState.dynamicOptions.subChargeTypeDropdownOptions]);

    const memoAllSubChgTypeOptions = useMemo(() => {
        const flattenedSubChgOptions = Object.values(discountMappingState.dynamicOptions.subChargeTypeDropdownOptions ?? {}).flat();
        const uniqueSubChgOptions = Array.from(
            new Map(flattenedSubChgOptions.map(option => [option.value, option])).values()
        );
        return uniqueSubChgOptions;
    }, [discountMappingState.dynamicOptions.subChargeTypeDropdownOptions]);

    const memochargeTariffCodeOptions = useMemo(() => {
        return currentEditRow.chargeTariffType
            ? discountMappingState.dynamicOptions.chargeTariffCodeDropdownOptions[currentEditRow.chargeTariffType]
            : [];
    }, [currentEditRow.chargeTariffType, discountMappingState.dynamicOptions.chargeTariffCodeDropdownOptions]);

    const memoChargeTariffType = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "260px", marginBottom: "20px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={!(isAdd || isEdit)}
                isShowOptional={true}
                readOnlyValue={currentEditRow?.chargeTariffType || ''}
                fieldValue={currentEditRow?.chargeTariffType}
                fieldLabel={DISCOUNT_MAPPING_CONSTANT.CHARGE_TAR_TYPE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'chargeTariffType'}
                options={discountMappingState.dynamicOptions.chargeTariffTypeDropdownOptions}
                maxLength={60}
                requiredFieldList={discountMappingRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    discountMappingVM.onHeaderFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [allFormState, isAdd, isEdit, currentEditRow?.chargeTariffType, DISCOUNT_MAPPING_CONSTANT.CHARGE_TAR_TYPE, isSaveClicked, discountMappingState.dynamicOptions.chargeTariffTypeDropdownOptions, discountMappingVM])

    const memoChargeTariffCode = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "260px", marginBottom: "20px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={!(isAdd || isEdit)}
                isShowOptional={true}
                readOnlyValue={currentEditRow?.chargeTariffCode || ''}
                fieldValue={currentEditRow?.chargeTariffCode}
                fieldLabel={DISCOUNT_MAPPING_CONSTANT.CHARGE_TAR_CODE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'chargeTariffCode'}
                options={memochargeTariffCodeOptions}
                maxLength={60}
                requiredFieldList={discountMappingRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    discountMappingVM.onHeaderFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [allFormState, isAdd, isEdit, currentEditRow?.chargeTariffCode, DISCOUNT_MAPPING_CONSTANT.CHARGE_TAR_CODE, isSaveClicked, memochargeTariffCodeOptions, discountMappingVM])

    const memoChargeType = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "260px", marginBottom: "20px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={!(isAdd || isEdit)}
                isShowOptional={true}
                readOnlyValue={currentEditRow?.chargeType || ''}
                fieldValue={currentEditRow?.chargeType}
                fieldLabel={DISCOUNT_MAPPING_CONSTANT.CHARGE_TYPE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'chargeType'}
                maxLength={60}
                options={discountMappingState.dynamicOptions.chargeTypeDropdownOptions}
                requiredFieldList={discountMappingRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    discountMappingVM.onHeaderFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [allFormState, isAdd, isEdit, currentEditRow?.chargeType, DISCOUNT_MAPPING_CONSTANT.CHARGE_TYPE, isSaveClicked, discountMappingState.dynamicOptions.chargeTypeDropdownOptions, discountMappingVM])

    const memoSubChargeType = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "260px", marginBottom: "20px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={!(isAdd || isEdit)}
                isShowOptional={true}
                readOnlyValue={currentEditRow?.subChargeType || ''}
                fieldValue={currentEditRow?.subChargeType}
                fieldLabel={DISCOUNT_MAPPING_CONSTANT.SUB_CHARGE_TYPE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'subChargeType'}
                maxLength={60}
                options={!currentEditRow?.chargeType && operatingUnit === 'OICT' ? memoAllSubChgTypeOptions : memoSubChgTypeOptions}
                requiredFieldList={discountMappingRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    discountMappingVM.onHeaderFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [allFormState, isAdd, isEdit, currentEditRow?.chargeType, currentEditRow?.subChargeType, DISCOUNT_MAPPING_CONSTANT.SUB_CHARGE_TYPE, isSaveClicked, memoSubChgTypeOptions, discountMappingVM, memoAllSubChgTypeOptions, operatingUnit])


    // const memoStatus = useMemo(() =>
    //     <div className='im-flex-row-item' style={{ width: "260px", marginBottom: "20px" }}>
    //         <NbisCommonField
    //             errorMessages={allFormState}
    //             isReadOnly={true}
    //             isShowOptional={true}
    //             readOnlyValue={currentEditRow?.status || ''}
    //             fieldValue={currentEditRow?.status}
    //             fieldLabel={DISCOUNT_MAPPING_CONSTANT.STATUS}
    //             isSaveClicked={isSaveClicked}
    //             fieldType={FieldType.TEXT}
    //             fieldKey={'status'}
    //             maxLength={60}
    //             sort={false}
    //             requiredFieldList={discountMappingRequiredFieldList}
    //             onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
    //                 discountMappingVM.onHeaderFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
    //     </div>
    //     , [currentEditRow?.status, DISCOUNT_MAPPING_CONSTANT.STATUS, discountMappingVM])

    const memoBillToCompany = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "260px", marginBottom: "20px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={!(isAdd || isEdit)}
                isShowOptional={false}
                readOnlyValue={currentEditRow?.billToCompanyCode || ''}
                fieldValue={currentEditRow?.billToCompanyCode}
                fieldLabel={DISCOUNT_MAPPING_CONSTANT.BILL_TO_COMPANY}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'billToCompanyCode'}
                maxLength={60}
                sort={false}
                isLimitOptions={true}
                options={discountMappingState.dynamicOptions.companyCodeDropdownOptions}
                requiredFieldList={discountMappingRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    discountMappingVM.onHeaderFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [allFormState, isAdd, isEdit, currentEditRow?.billToCompanyCode, DISCOUNT_MAPPING_CONSTANT.BILL_TO_COMPANY, isSaveClicked, discountMappingState.dynamicOptions.companyCodeDropdownOptions, discountMappingVM])

    const memoActiveInd = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "260px", marginBottom: "20px" }}>
            <NbisCommonField
                fieldKey={"activeInd"}
                requiredFieldList={[]}
                fieldLabel={DISCOUNT_MAPPING_CONSTANT.ACTIVE_IND}
                fieldType={FieldType.TEXT}
                isReadOnly={true}
                onFieldChange={() => { }} />
            <HPHCheckbox
                label={""}
                checked={currentEditRow?.activeInd === 'Y'}
                disabled={!(isAdd || isEdit)}
                onChange={(e) => discountMappingVM.onCheckboxChange(e.checked, "activeInd")}
            />
        </div>
        , [DISCOUNT_MAPPING_CONSTANT.ACTIVE_IND, discountMappingVM, currentEditRow?.activeInd, isAdd, isEdit])

    const memoPercentage = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "260px", marginBottom: "20px" }}>
            <NumberInputComponent
                label={DISCOUNT_MAPPING_CONSTANT.DISCOUNT_PERCENTAGE}
                maxLength={6}
                fieldName={"percentage"}
                value={currentEditRow?.percentage ?? ''}
                errorMessage={allFormState ? allFormState["percentage"] ?? '' : ''}
                disabled={!(isAdd || isEdit)}
                decimalPlaces={2}
                onChange={(e: any, fieldKey: string, fieldValue: any) => onNumberFieldChange(e, fieldKey, fieldValue)}
            />
        </div>
        , [DISCOUNT_MAPPING_CONSTANT.DISCOUNT_PERCENTAGE, allFormState, currentEditRow?.percentage, isAdd, isEdit, onNumberFieldChange])

    const handleEdit = useCallback(() => {
        discountMappingVM.onEditClick();
    }, [discountMappingVM]);

    const handleReset = useCallback(() => {
        discountMappingVM.onResetClick(isAdd);
    }, [discountMappingVM, isAdd]);

    const isAllowEdit = () => {
        if (currentEditRow.status === 'FINALIZED') return false
        return true;
    }

    return <>
        <StyledSidebar style={{ width: '100%', height: "100%", border: 'none', backgroundColor: '#FFFFFF', overflow: 'auto', padding: '0' }} position='right'>
            <Sidebarheader style={{ width: '100%' }}>
                {isLoading && <Loader Indicator="Spinner" size="Medium" />}
                <Breadcrumb>
                    <HPHBreadcrumb breadcrumbData={[{ title: DiscountMappingConstant.Title.CATEGORY },
                    { title: DiscountMappingConstant.Title.TITLE }]} onCurrentClick={() => { }}>
                    </HPHBreadcrumb>
                </Breadcrumb>
                <StyledAction>
                    <>
                        {allowUpdate && (isAllowEdit() && !(isAdd || isEdit)) && <NbisIconButton fileName='Icon-pen' size='medium' disabled={false} toolTipArrow={false} toolTipPlacement="bottom" toolTipText={'Edit'} onClick={handleEdit} />}
                        {(isAllowEdit() && (isAdd || isEdit)) && <IconButton fileName="Icon-reset" size="medium" disabled={false} toolTipArrow={false} toolTipPlacement="bottom" toolTipText={'Reset'} onClick={() => handleReset()} />}
                        <IconButton fileName="Icon-cross" size="medium" disabled={false} toolTipArrow={false} toolTipPlacement='bottom' toolTipText={'Close'} onClick={() => handClose()} />
                        {(isAllowEdit() && (isAdd || isEdit)) && <IconButton fileName="Icon-tick" size="medium" disabled={false} toolTipArrow={false} toolTipPlacement="bottom" toolTipText={'Save'} onClick={() => handleSave()} />}
                    </>
                </StyledAction>
            </Sidebarheader>

            <div className={'add-edit-form'} style={{ height: 'calc(100vh - 125px)', maxHeight: 'calc(100vh - 125px)', overflow: 'auto' }}>
                <div className="flex-row-auto">
                    <div className={'flex-row-item'}>
                        <div className={'im-flex-row'}>
                            <div className={'flex-row-item-stretch'}>
                                <SidebarTitle>
                                    {isAdd && "New Discount"}
                                    {!isAdd && (currentEditRow.priority + "/" + currentEditRow.percentage)}
                                </SidebarTitle>
                                {<SidebarCaption>"All fields are required unless indicated as 'optional'"</SidebarCaption>}
                            </div>
                        </div>
                        <br />
                        <CriteriaItemContainer>
                            {/* {memoStatus} */}
                            {memoPercentage}
                            {memoBillToCompany}
                        </CriteriaItemContainer>
                        <CriteriaItemContainer>
                            {memoChargeType}
                            {memoSubChargeType}
                        </CriteriaItemContainer>
                        <CriteriaItemContainer>
                            {memoChargeTariffType}
                            {memoChargeTariffCode}
                        </CriteriaItemContainer>
                        <CriteriaItemContainer>
                            {memoActiveInd}
                        </CriteriaItemContainer>
                    </div>
                </div>
            </div>
        </StyledSidebar>
    </>
}

export default memo(DiscountMappingEditPanel);
